import { AnimatePresence, motion } from "framer-motion";

const ORDER = [-1, 1, -2, 2, -3, 3];

function Figure({ k }) {
  const id = `sil-${k}`;
  return (
    <svg viewBox="0 0 60 84" className="bench-figure h-auto w-full" style={{ animationDelay: `${(k + 3) * 0.9}s` }} aria-hidden>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FFFFFF" stopOpacity="0.78" />
          <stop offset="1" stopColor="#E9DDF7" stopOpacity="0.32" />
        </linearGradient>
      </defs>
      <ellipse cx="30" cy="16" rx="10.5" ry="12.5" fill={`url(#${id})`} />
      <path d="M30 31 C17 31 11 38 10 50 L8 84 L52 84 L50 50 C49 38 43 31 30 31 Z" fill={`url(#${id})`} />
    </svg>
  );
}

export function BenchRow({ others, narrow }) {
  const n = Math.min(6, Math.max(0, others));
  const step = narrow ? 14 : 12;
  return (
    <div data-testid="bench-row" data-silhouettes={n} className="relative h-[92px] shrink-0 sm:h-[118px]">
      <div className="absolute inset-x-[6%] bottom-3 h-2 rounded-full bg-white/25 shadow-[0_0_18px_rgba(255,214,236,0.45)]" />
      <AnimatePresence>
        {ORDER.slice(0, n).map((k, i) => (
          <motion.div
            key={k}
            data-testid={`bench-silhouette-${i}`}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 6 }}
            transition={{ duration: 2.2, ease: "easeInOut" }}
            style={{ left: `${50 + k * step}%`, x: "-50%", opacity: 0.9 }}
            className="absolute bottom-5 w-[50px] sm:w-[66px]"
          >
            <Figure k={k} />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
